import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × MICHELANGELO: Sculptural form in digital space
// 3D relief grids, dynamic contours, monolithic abstraction
export function VasarelyMichelangeloMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Monolithic central form with 3D relief effect */}
      <g transform="translate(397 540)">
        {/* Shadow layers creating depth */}
        {Array.from({ length: 8 }).map((_, i) => {
          const offset = i * 15;
          const opacity = 0.15 - i * 0.015;
          return (
            <rect
              key={`shadow-${i}`}
              x={-180 + offset}
              y={-240 + offset}
              width="360"
              height="480"
              fill={brand.deep}
              opacity={opacity}
            />
          );
        })}

        {/* Main sculptural form */}
        <rect x="-180" y="-240" width="360" height="480" fill={brand.violet} opacity="0.3" />
        
        {/* Dynamic contour lines (muscular tension) */}
        {Array.from({ length: 20 }).map((_, i) => {
          const y = -220 + i * 24;
          const wave = Math.sin(i * 0.5) * 40;
          const width = 300 - Math.abs(i - 10) * 15;
          return (
            <path
              key={i}
              d={`M ${-width / 2 + wave} ${y} Q 0 ${y + 8} ${width / 2 + wave} ${y}`}
              fill="none"
              stroke={i % 2 === 0 ? brand.aqua : brand.amber}
              strokeWidth="3"
              opacity={0.6}
            />
          );
        })}

        {/* Optical grid creating volume */}
        {Array.from({ length: 12 }).map((_, i) =>
          Array.from({ length: 8 }).map((_, j) => {
            const x = -150 + i * 28;
            const y = -200 + j * 60;
            const depth = Math.sin(i * 0.3) * Math.cos(j * 0.4) * 15;
            return (
              <rect
                key={`${i}-${j}`}
                x={x + depth}
                y={y - depth}
                width="20"
                height="20"
                fill={brand.white}
                opacity={0.15 + Math.abs(depth) * 0.02}
                transform={`rotate(${depth * 2} ${x + 10 + depth} ${y + 10 - depth})`}
              />
            );
          })
        )}

        {/* Tension lines (structural power) */}
        {[-120, 0, 120].map((x) => (
          <line
            key={x}
            x1={x}
            y1="-240"
            x2={x}
            y2="240"
            stroke={brand.violet}
            strokeWidth="2"
            opacity="0.4"
            strokeDasharray="8 4"
          />
        ))}

        {/* Chiseled edges */}
        <rect x="-180" y="-240" width="360" height="480" fill="none" stroke={brand.white} strokeWidth="4" opacity="0.6" />
      </g>

      {/* Monolithic presence marker */}
      <text x="397" y="920" textAnchor="middle" fontFamily="serif" fontSize="12" fill={brand.white} opacity="0.5" fontStyle="italic">
        forma e potenza
      </text>
    </g>
  );
}
